import 'regenerator-runtime/runtime'

import _theme from 'components/theme'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { createGlobalStyle, ThemeProvider } from 'styled-components'
import { color, theme, zIndex } from 'utils'
import { setJWTToken } from 'utils/tokenHelper'

import configureStore from './configureStore'
import normalize from './normalize'
import ConnectedIntl from './providers/ConnectedIntl'
import Main from './scenes/App/Main'

performance.mark('React:start')
performance.measure('React booting', 'DOM:end', 'React:start')

// Dynamically load mocks if flag is on
if (MOCK_BE) {
  import('utils/mocks/mockedServer').then((MockServer) => {
    window.mocks = MockServer.default
  })
}

// eslint-disable-next-line
__webpack_nonce__ = 'dqqMIKs3Hb48v1CDudZ7fPRhuiawsY3J'

const GlobalStyle = createGlobalStyle`
  ${normalize()};

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  *::-webkit-scrollbar {
    width: 4px !important;
    height: 4px !important;
  }

  *::-webkit-scrollbar-thumb {
    background: ${color('dark700')};
    border-radius: 3px;
  }


  *::-webkit-scrollbar-track {
    background: transparent;
  }

  html {
    font-family: ${theme('fontPrimary')};
    font-size: ${theme('baseFontSize')};
    font-feature-settings: 'tnum' 1, 'zero', 'kern' 1;
    line-height: 1.3;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    scroll-behavior: smooth;
  }

  body {
    background: ${color('dark900')};

    > div:last-child .fade-enter-done {
      z-index: ${zIndex(4)};
    }
  }

  html,
  body,
  #app {
    min-height: 100%;
    height: 100%;
    min-width: 100%;
    -webkit-overflow-scrolling: touch;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }
`

// JWT passed view HTML render
if (window.JWT && window.JWT !== '===JWT===') {
  setJWTToken(window.JWT)
}

// JWT passed via query string
const query = new URLSearchParams(window.location.search)
const jwtStr = query.get('jwt')
if (jwtStr) {
  setJWTToken(jwtStr)
  query.delete('jwt')
  const nextUrl = `${window.location.pathname}?${query.toString()}`
  window.location.replace(nextUrl)
}

const store = configureStore()

const container = document.getElementById('app')

const router = createBrowserRouter([
  {
    element: <Main />,
    path: '*'
  }
])

if (container) {
  const root = createRoot(container)
  root.render(
    <Provider store={store}>
      <ConnectedIntl>
        <ThemeProvider theme={_theme}>
          <>
            <GlobalStyle />
            <RouterProvider router={router} />
          </>
        </ThemeProvider>
      </ConnectedIntl>
    </Provider>
  )
}
